import { palette } from "../theme";

export default class Defines {
  static get PrimaryColor() {
    return palette.primary.main;
  }
}
